<template>
  <span v-if="item[slotData.name] && item[slotData.name].length">
    <template v-for="(i, index) in item[slotData.name]">
      <LinkItem
        v-bind:key="'link-' + index"
        :item="i"
        :slot-data="slotData"
      ></LinkItem>
      <span v-bind:key="index" class="groups-arrow">
        <v-icon v-if="slotData.icon" class="mdi">{{ slotData.icon }}</v-icon>
        <template v-else>{{ slotData.divider || ", " }}</template>
      </span>
    </template>
  </span>
</template>
<script>
import LinkItem from "./LinkItem";
export default {
  name: "GroupsItem",
  components: {
    LinkItem
  },
  props: {
    slotData: {
      type: Object
    },
    item: {
      type: Object
    }
  }
};
</script>

<style scoped>
.groups-arrow:last-of-type {
  display: none;
}
</style>
